<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="资料管理" name="first">
                <datumn-manage ref="Datumn"></datumn-manage> 
            </el-tab-pane>
            <el-tab-pane label="奖惩标准" name="second">
                <punish-record ref="Punish"></punish-record>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>
<script>
import DatumnManage from './components/DatumnManage.vue'//资料管理
import PunishRecord from './components/PunishRecord.vue'//奖惩标准
export default {
    components:{
        DatumnManage,
        PunishRecord,
    },
    data(){
        return{
            activeName:'first'
        }
    },
    mounted(){
        this.$refs.Datumn.searchButtonInfo(true);
    },
    methods:{
        //切换界面
        handleClick(tab){
            switch(tab.name){
                case 'second':
                    this.$refs.Punish.searchButtonInfo(true);
                    break;
                default:
                    this.$refs.Datumn.searchButtonInfo(true);
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import'@/style/layout-main.scss';
/deep/ .el-tabs__content{
    position: static;
}

/deep/.main {
  background: none;
}
</style>